import { Button } from '@/_shared/components/ui/button';
import { Callout } from '@/_shared/components/ui/callout';

import { TextButton } from './TextLink';

/** Two-factor enrollment lives in the RudderStack web app; config-backend sends no tokens until it is done. */
export function MfaSetupRequired({ webAppUrl, onBack }: { webAppUrl: string; onBack: () => void }): React.ReactElement {
  return (
    <div className="flex flex-col gap-4 text-left">
      <Callout variant="warning" role="status">
        Your organization requires two-factor authentication. Set it up in RudderStack, then sign in here again.
      </Callout>
      <Button variant="primary" size="lg" className="w-full" asChild>
        <a href={`${webAppUrl.replace(/\/+$/, '')}/login`}>Set up in RudderStack</a>
      </Button>
      <div className="flex justify-center">
        <TextButton onClick={onBack}>Back to sign in</TextButton>
      </div>
    </div>
  );
}
